import { ConfirmationService, MessageService } from 'primeng/api';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TabsModule } from 'primeng/tabs';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { map } from 'rxjs';
import { ButtonModule } from 'primeng/button';
import { Destination, Article, ArticleType, ArticleService } from '../../shared/public-api';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'admin-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.scss'],
  imports: [
    CommonModule,
    ToastModule,
    ConfirmDialogModule,
    TabsModule,
    TableModule,
    RouterModule,
    InputTextModule,
    ButtonModule,
  ],
  providers: [ConfirmationService, MessageService],
})
export class ArticlesComponent implements OnInit {
  baseUrl: string;

  destinations: Destination[] = [];
  destinationArticles: { [destinationId: string]: Article[] } = {};
  setupArticles: Article[];
  articleType: ArticleType;
  ArticleType = ArticleType;

  constructor(
    private articleService: ArticleService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private route: ActivatedRoute
  ) {
    this.baseUrl = environment.baseUrl;
  }

  ngOnInit(): void {
    if (this.route.snapshot.data && this.route.snapshot.data['articleType']) {
      this.articleType = this.route.snapshot.data['articleType'];
    }
    this.getArticles();
  }

  getArticles(): void {
    this.destinations = [];
    this.destinationArticles = {};
    let request = this.articleService.getArticlesWithDraft().pipe(
      map((articles) => {
        return this.setDestinationArticles(articles);
      })
    );
    if (this.articleType === ArticleType.Accommodation) {
      request = this.articleService.getAccomodationsWithDraft().pipe(
        map((articles) => {
          return this.setDestinationArticles(articles);
        })
      );
    } else if (this.articleType === ArticleType.Setup) {
      request = this.articleService
        .getSetupsWithDraft()
        .pipe(map((articles) => (this.setupArticles = articles)));
    }

    request.subscribe(() => {
      if (this.articleType !== ArticleType.Setup) {
        this.destinations = this.destinations.sort((a, b) => (a.country > b.country ? 1 : -1));
      }
    });
  }

  deleteArticle(event: MouseEvent, articleId: string): void {
    event.stopPropagation();
    this.confirmationService.confirm({
      message: 'Etes-vous sûr de supprimer cet article?',
      header: 'Supprimer un article',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.articleService.deleteArticle(articleId).subscribe(
          () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Ok',
              detail: 'Article supprimé!',
            });
            this.getArticles();
          },
          (err) =>
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Une erreur est survenue!',
            })
        );
      },
    });
  }

  private setDestinationArticles(articles: Article[]): Article[] {
    articles
      .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
      .forEach((article) => {
        const destination = this.destinations.find((x) => x.id === article.destinationId);
        if (!destination) {
          this.destinations.push(article.destination as Destination);
        }

        let destinationArticle = this.destinationArticles[article.destinationId];
        if (!destinationArticle) {
          destinationArticle = [];
          this.destinationArticles[article.destinationId] = destinationArticle;
        }
        destinationArticle.push(article);
      });
    return articles;
  }
}
